export const element = document.querySelector('div[data-leads-form]') as HTMLElement;
export const lang = (
    element.attributes.getNamedItem('data-lang')?.value
    ?? document.documentElement.lang
).substring(0, 2).toLowerCase()
export const langNamespace =
    element.attributes.getNamedItem('data-lang-ns')?.value;

const id = element.attributes.getNamedItem('data-leads-form')?.value
if (!id) {
    throw new Error('Form ID not defined.')
}

const productionUrl = 'https://leads-api.technoly.com/'
const currentScript = document.currentScript ? document.currentScript as HTMLScriptElement : null

export const apiUrl = element.attributes.getNamedItem('data-leads-api')?.value ?? productionUrl
export const formId = id
export const theme = element.attributes.getNamedItem('data-leads-theme')?.value
export const frontendDomain = currentScript ? 'https://' + (new URL(currentScript.src)).hostname : 'https://leads-frontend.technoly.com/'
